export enum UserType {
  NORMAL = 'normal',
  CREATED = 'created',
  DELETED = 'deleted',
  BLOCKED = 'blocked',
  DEACTIVATED = 'deactivated'
}

export enum AuthProvider {
  PASSWORD = 'password',
  MICROSOFT = 'microsoft'
}

export interface UserBase {
  id: string;
  email?: string | null;
  phone?: string | null;
  name: string;
  lastName: string;
  userType: UserType;
  statusUpdateTimestamp: number | null;
  fcmToken?: string | null;
  language: string;
  createDate: number;
  apnToken?: string | null;
  lastActivity?: number;
  lastLoginAttempt?: number;
  /** Authentication method used - null means password */
  authProvider?: AuthProvider | null;
  /** Azure AD Object ID for SSO users (from OIDC token claim 'oid' or 'sub') */
  providerId?: string;
}

export interface UserData extends UserBase {
  email: string;
  phone?: string | null;
  address?: string | null;
  apnTokenACA?: string | null;
  fcmTokenACA?: string | null;
  /** @warning determines last/current logged estate for mobile and CAN NOT be used to filter users */
  contextEstateId: string;
  passwordSetDate?: number;
  /** Bluebolt connection user id */
  blueboltId?: string | null;
}

export interface ServiceUserData extends UserBase {
  /** Legacy users only */
  email?: string | null;
  /** Required for new users */
  phone?: string;
  /** required for new users */
  subcontractorId: string;
  estates: string[] | null;
  lastFilters?: { [key: string]: string };
}

export interface EstateAdminData {
  /** $userId|$estateId */
  id: string;
  userId: string;
  estateId: string;
  createTimestamp: number;
}

export interface UserPermissions {
  id: string;
  userId: string;
  estateId: string;
  messageResponseDefault?: boolean; // if false, user cannot response to chat messages bu default; null means true
  bookingLocationsBan: BookingBan[]; // list of locations where user cannot book within time
}

export interface BookingBan {
  locationId: string;
  banStartDate: number;
  banEndDate: number;
  banReason: string;
  adminId: string;
  cancelTimestamp?: number;
  cancelAdminId?: string;
  /** related users ids - in community all shareholders + tenants, in PRS -all landlords and tenants in all his agreements */
  relatedUsers?: string[];
}

